import { useState } from "react";
import api from "../api";
import handleApiError from "../utils/handleApiError";
import { Box, Card, CardContent, TextField, Button, Typography, Snackbar, Alert, Stack } from "@mui/material";

export default function CustomerFeedback() {
  const [form, setForm] = useState({
    name: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [apiError, setApiError] = useState("");

  // 🔍 Validation logic
  const validate = (values = form, field) => {
    const e = {};
    if (field === "message") {
      if (!values.message.trim()) {
        e.message = "Это обязательное поле";
      } else {
        setLoading(false);
      }
    }

    if (!field) {
      if (!values.message.trim()) {
        e.message = "Это обязательное поле";
      }
    }

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleChange = (field, value) => {
    const updated = { ...form, [field]: value };
    setForm(updated);
    validate(updated, field); // realtime validation
  };

  const submitFeedback = async (e) => {
    e.preventDefault();
    setApiError("");

    if (!validate()) return;

    setLoading(true);
    try {
      await api.post("/feedback", form);
      setSuccess(true);
      setForm({ name: "", message: "" });
      setErrors({});
    } catch (err) {
      setApiError(handleApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url("background.jpg")`,
        backgroundRepeat: "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Card sx={{ maxWidth: 500, width: "100%", borderRadius: 3, m: 1 }}>
        <CardContent>
          <img src="cyberium.gif" alt="Logo" width={"100%"} />
          <Stack spacing={2}>
            <Typography variant="h5" fontWeight="bold">
              Мы ценим ваши отзывы 💬
            </Typography>

            <Typography color="text.secondary">Расскажите нам, что у нас получилось хорошо или как мы можем улучшить свою работу.</Typography>

            {apiError && <Alert severity="error">{apiError}</Alert>}

            <TextField label="Ваше имя (по желанию)" value={form.name} error={!!errors.name} helperText={errors.name} onChange={(e) => handleChange("name", e.target.value)} />

            <TextField label="Комментарий" multiline rows={4} value={form.message} error={!!errors.message} helperText={errors.message} onChange={(e) => handleChange("message", e.target.value)} required />

            <Button variant="contained" size="large" disabled={loading || Object.keys(errors).length > 0} onClick={submitFeedback}>
              Отправить
            </Button>
          </Stack>
        </CardContent>
      </Card>

      <Snackbar open={success} autoHideDuration={3000} onClose={() => setSuccess(false)}>
        <Alert severity="success" variant="filled">
          Спасибо! Ваш отзыв успешно отправлен 🙌
        </Alert>
      </Snackbar>
    </Box>
  );
}
